module.exports = __webpack_public_path__ + "media/images/logos/watermark-black-524d5abea75cdafd7315e07c89e69573.svg";